import { IClientsRepository } from "@/repository/clients/ClientsRepository.types";
import { IClients, IClientsListItem, ClientsResponseType } from "@/entity/clients/clients.types";

import Api from "@/repository/api";
import Clients from "@/entity/clients/clients";
import { ClientGeneralRequestType } from "@/form/clientGeneral/clientGeneral.types";
import qs from "qs";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";
import { PaymentAccount, PaymentAccountRefill } from "@/entity/clients/Accounts/account.types";

export class ClientsRepository implements IClientsRepository {
    async fetchAll(data?: FormData): Promise<IClients> {
        console.log("fetchAll")
        const response = await Api.get(`/clients/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        const responseData = response.data as ClientsResponseType;
        return new Clients(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IClientsListItem> {
        console.log("fetchData")
        const response = await Api.get(`/clients/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        });
        const responseData = response.data as ClientsResponseType;
        return new Clients(responseData).data[0];
    }
    async create(data: ClientGeneralRequestType): Promise<boolean> {
        const response = await Api.post(`/clients/create`, data);
        return response.data;
    }
    async createPaymentAccount(data: PaymentAccount): Promise<ResponseDataType> {
        const response = await Api.post("/clients/account/open", data);
        return response.data;
    }
    async refillPaymentAccount(data: PaymentAccountRefill): Promise<ResponseDataType> {
        const response = await Api.post("/clients/account/refill", data);
        return response.data;
    }
    async update(data: ClientGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/clients/update`, data);
        return response.data;
        //return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/clients/delete`, data);
        return response.data;
        //return responseData;
    }
}
